import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { SettingsClearProgressWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import Alert from 'components/alert';
import Button from 'components/button/button';
import { Theme } from '@seedlang/constants';
import Text from 'components/text';
import Checkbox from 'components/checkbox';
import Spinner from 'components/spinner';
import Modal from 'components/modal';
import { gaps } from 'components/layout/stack';

const Wrapper = styled.div`

`;

const ConfirmModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.md};
  p {
    margin: 0;
  }
`;

const ConfirmButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${props => gaps[props.gap]};

  & > * {
    width: 100%;
  }
`;

const ConfirmLinkButton = styled.button`
  background: none;
  border: none;
  color: ${Theme.darkestBlue};
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 0;
  &:hover {
    opacity: 0.8;
  }
`;

const CheckboxesWrapper = styled.div`
  margin-bottom: 20px;
`;

@observer
class SettingsClearProgress extends React.Component {

  @observable showConfirmClearModal = false;

  render() {
    return (
      <Wrapper>
        {
          Boolean(this.showConfirmClearModal) &&
          <Modal
            onCloseModal={() => this.showConfirmClearModal = false}
            width='100%'
            maxWidth='440px'
            title='Clear progress'
            background={Theme.red}
            contentBackground='#FFF'
          >
            <ConfirmModalBody>
              <p>Are you sure you want to clear the selected progress?</p>
              <p>This cannot be undone.</p>
              <ConfirmButtonGroup gap='md'>
                <ConfirmButtonGroup gap='sm'>
                  <Button
                    onClick={() => {
                      this.showConfirmClearModal = false;
                      this.props.clearProgress();
                    }}
                    background={Theme.red}
                    width='100%'
                    height='50px'
                    borderRadius='30px'
                  >
                    Clear progress
                  </Button>
                </ConfirmButtonGroup>
                <ConfirmLinkButton
                  type="button"
                  onClick={() => this.showConfirmClearModal = false}
                >
                  Cancel
                </ConfirmLinkButton>
              </ConfirmButtonGroup>
            </ConfirmModalBody>
          </Modal>
        }
        <Text
          heading='3'
          margin='0 0 10px 0'
        >
          Clear Progress
        </Text>
        <Text margin='0 0 20px 0'>
          {this.props.introText}
        </Text>
        {
          this.props.message && this.props.showMessage &&
            <Alert
              textAlign='center'
            >
              {this.props.message}
            </Alert>
        }
        {
          this.props.showSpinner &&
            <Spinner margin='20px 0' />
        }
        <CheckboxesWrapper>
          {
            this.props.progressTypes.map(({ type, label }) =>
              <Row
                key={type}
                onClick={() => this.props.toggleType(type)}
              >
                <Checkbox value={this.props.selectedTypes[type]} />
                <Text>{label}</Text>
              </Row>
            )
          }
        </CheckboxesWrapper>
        {
          this.props.selectedWarnings.map(warning =>
            <Text
              key={warning}
              color={Theme.red}
              margin='0 0 5px 0'
            >
              {warning}
            </Text>
          )
        }
        <Button
          background={Theme.red}
          disabled={!this.props.hasSelection}
          margin='10px 0 0 0'
          onClick={() => this.showConfirmClearModal = true}
        >
          Clear Selected Progress
        </Button>
      </Wrapper>
    );
  }
}

export default SettingsClearProgressWrapper(SettingsClearProgress);
